import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";
import OffsetLine from "../Lines/OffsetLine";
import { IPoint } from "makerjs";
import GuideLine from "../Lines/GuideLine";

export class ArchedRectangle extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'arched-rectangle', dimensions );
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height;
	}

	getLength(): Length {
		return this.cleanedPrimitives.height;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width;
	}

	getRatios(): Ratio[] {
		return [
			{
				firstDimension: 'height',
				secondDimension: 'width',
				ratio: 0.5,
			}
		];
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'height', secondary: 'width' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		const arcHeight = this.getHeight().in_mm() - this.getWidth().in_mm() / 2;

		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [0, 0], [ 0, this.getHeight().in_mm() ], this.renderDimensionLabel( 'height' ), [-40, 0], ratio, this.getDimensionLineType('measurements-arched-rectangle-height', focusedElement, forceRender) ),
				new DimensionLine( [0, 0], [ this.getWidth().in_mm(), 0 ], this.renderDimensionLabel( 'width' ), [0, -40], ratio, this.getDimensionLineType('measurements-arched-rectangle-width', focusedElement, forceRender) ),
				new DimensionLine( [this.getWidth().in_mm() / 2, 0], [this.getWidth().in_mm() / 2, arcHeight], this.renderDimensionLabel( 'height', new Length(arcHeight) ), [0, 0], ratio ),
			];
		}

		return [];
	}

	getGuideLines(focusedElement = ''): GuideLine[] {
		const arcHeight = this.getHeight().in_mm() - this.getWidth().in_mm() / 2;
		return [
			new GuideLine( [0, arcHeight], [this.getWidth().in_mm(), arcHeight] ),
		];
	}

	/**
	 * Creates a model instance of the shape.
	 */
	createModel(): void {
		if ( ! this.cleanedPrimitives.height || ! this.cleanedPrimitives.width ) {
			return;
		}

		super.createModel();
	}

	getDefaultDimensions(): Dimensions {
		return {
			width: 50,
			height: 75,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();
		const height = enclosingRectangle.height();

		return {
			width: width.divide(2).in_cm(),
			height: height.divide(2).in_cm(),
		};
	}
}
